import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";

import CKEditor from "react-ckeditor-component";
import { sendContractMail } from "../../../redux/actions/contractActions";
import { get_merchant_details_id } from "../../../redux/actions/merchantActions";
import auth               from '../../../services/auth';
import { get_site_details } from "../../../redux/actions/siteActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {};


let message, isLoading="false";
class SendMail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path : ["Home", "Contract", "Mail"],
      message: '',
      to: '',
      firstName: '',
      lastName: '',
      fromName: '',
      fromEmail: '',
      fromPhone: '',
      subject: '',
      toError: '',
      subjectError: '',
      alertMessage: "",
      show: false,
      buttonValue: 'Send Mail',
      disabled: false,
    };

    this.message = this.message.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  message = (evt) => {
    this.setState({
      message: evt.editor.getData()
    });
  } 
  handleChange = (e) => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({[e.target.name] : e.target.value})
  }
  valid = () => {
    let status = true;

    if(!this.state.to){
      status = false;
      this.setState({toError: 'red'});
    }

    if(!this.state.subject){
      status = false;
      this.setState({subjectError: 'red'});
    }

    return status;
  }
  handleSubmit = (e) => {
    e.preventDefault();
    let validate = this.valid();
    if(validate){
      this.setState({buttonValue: 'Sending...', disabled: true});
      isLoading = "true";
      const constData = {
        email_address: this.state.to,
        subjectLine: this.state.subject,
        emailContent: (this.state.message) ? this.state.message : message,
      }
      this.props.sendContractMail(constData);
    }
  } 

  componentDidMount() {
    
  }

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    let merchantIdParams = this.props.match.params.merchantID
      ? this.props.match.params.merchantID
      : "";
    if (merchantIdParams !== "") {
      isLoading = "true"; 

      this.props.get_merchant_details_id({merchantId:merchantIdParams, contractID:this.props.match.params.contractID});
    }

    let user = auth.getUserInfo()  ? auth.getUserInfo() : null;
    if(user.siteID != ''){
      this.props.get_site_details(user.siteID);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.merchantDetails !== nextProps.merchantDetails){ 
      if(nextProps.merchantDetails){
        this.setState({to: nextProps.merchantDetails.email, legalName: nextProps.merchantDetails.legalName, firstName: nextProps.merchantDetails.firstName, lastName: nextProps.merchantDetails.lastName, message:nextProps.merchantDetails.mailContent, })
      }
    }

    if(this.props.siteDetails !== nextProps.siteDetails){
      if(nextProps.siteDetails){
        isLoading = "false";
        this.setState({fromName: nextProps.siteDetails.firstName+' '+nextProps.siteDetails.lastName, fromEmail: nextProps.siteDetails.email, fromPhone:nextProps.siteDetails.phone })
      }
    }

    if(this.props.mailStatus !== nextProps.mailStatus){
      if(nextProps.mailStatus){
        isLoading = "false";
        this.setState({buttonValue: 'Send Mail', disabled: false});
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.mailStatus.message);
        window.scrollTo(0, 0);
      }
    }

    if(this.props.error !== nextProps.error){
      if(nextProps.error){
        isLoading = "false";
        this.setState({buttonValue: 'Send Mail', disabled: false});
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if(this.props.mailError !== nextProps.mailError){
      if(nextProps.mailError){
        isLoading = "false";
        this.setState({buttonValue: 'Send Mail', disabled: false});
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.mailError);
        window.scrollTo(0, 0);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      window.scrollTo(0, 0);
    }
  }

 

  render() {
    if((this.state.fromName && this.state.firstName) || true){
    message = `<div><strong>Hi ${(this.state.legalName) ? this.state.legalName : ''},</strong><p>To view the proposal simply click the link below. If you have any questions or need me to make any adjustments, please don’t hesitate to reach out to me by phone or email.</p><p><a href='${location.protocol}//${location.host}/proposal/${this.props.match.params.contractID}'>${location.protocol}//${location.host}/proposal/${this.props.match.params.contractID}</a></p><p>If everything looks good, simply sign the proposal with your mouse, trackpad or finger and we will get the ball rolling right away.</p><p>I am looking forward to working with you on this!</p><p><b>${this.state.fromName}</b><br/>${this.state.fromEmail}<br/>${this.state.fromPhone}</p></div>`;
    }
    return (
        <div className="col-lg-12 list-page">
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Email Contract</header>
            <form onSubmit={this.handleSubmit}>
            <div className="panel-body">
              <Row>
                {this.state.show &&
                  this.state.alertMessage !== "" && (
                    <Col md={12}>
                      <Alert
                        bsStyle={this.state.msgType}
                        onDismiss={this.handleDismiss}
                      >
                        <strong>{this.state.msgType}:</strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </Col>
                )}
                <Col md={8}>
                  <FormGroup>
                    <ControlLabel>To (Protip: To send the same proposal to multiple recipients, separate the emails with commas):</ControlLabel>
                    <FormControl
                      type="text"
                      name="to"
                      value={this.state.to}
                      onChange={this.handleChange}
                      style={{
                        borderColor: this.state.toError
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={8}>
                  <FormGroup>
                    <ControlLabel>Subject Line:</ControlLabel>
                    <FormControl
                      type="text"
                      name="subject"
                      value={this.state.subject}
                      onChange={this.handleChange}
                      style={{
                        borderColor: this.state.subjectError
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={8}>
                  <FormGroup>
                    <ControlLabel>Personalized Message:</ControlLabel>
                    <CKEditor
                      activeClass="p10"
                      content={(this.state.message) ? this.state.message : message}
                      events={{
                        change: this.message
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={8}>
                <Button type="submit" bsStyle="primary" disabled={this.state.disabled}>{this.state.buttonValue}</Button>
                </Col>
              </Row>

            </div>
            </form>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    merchantDetails: state.merchantReducer.merchantDetails,
    siteDetails: state.siteReducer.siteDetails,
    error: state.merchantReducer.error,
    mailStatus: state.contractReducer.mailStatus,
    mailError: state.contractReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {get_merchant_details_id, get_site_details, sendContractMail, renderAlert, clearAlert})
)(SendMail);



// WEBPACK FOOTER //
// ./src/app/views/admin/contract/SendMail.js